module.exports = __webpack_public_path__ + "img/I.dee19280.jpg";